// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3613":"8eb2f389","5693":"f92d21c6"}[chunkId] + ".chunk.css";
};